import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { Link } from 'react-router-dom';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import AvatarComponent from 'components/base/Avatar'; //this has ben renamed due to conflict with Avatar from user
import { Member } from 'data/members';
import { formatDate, formatDistanceToNow } from 'date-fns';

export const membersTablecolumns: ColumnDef<Member>[] = [
  {
    accessorKey: 'lastname',
    header: 'Last Name',
    cell: ({ row: { original } }) => {
      const { id, lastName, avatar } = original;
      return (
        <Link
          to={`/profile/${id}`}
          className=" d-flex align-items-center text-900 text-hover-1000"
        >
          <AvatarComponent src={avatar} size="m" />
          <p className="mb-0 ms-3 text-1100 fw-semi-bold">{lastName}</p>
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%', minWidth: '200px' },
        className: 'px-1'
      },
      cellProps: { className: 'align-middle white-space-nowrap py-2' }
    }
  },
  {
    accessorKey: 'firstname',
    header: 'First Name',
    cell: ({ row: { original } }) => {
      const { id, firstName } = original;
      return (
        <Link
          to={`/profile/${id}`}
          className=" d-flex align-items-center text-900 text-hover-1000"
        >
          <p className="mb-0 ms-3 text-1100 fw-semi-bold">{firstName}</p>
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%', minWidth: '200px' },
        className: 'px-1'
      },
      cellProps: { className: 'align-middle white-space-nowrap py-2' }
    }
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row: { original } }) => {
      const { email } = original;
      return (
        <Link to={`mailto:${email}`} className="fw-semi-bold">
          {email}
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '15%', minWidth: '200px' }
      },
      cellProps: { className: 'white-space-nowrap' }
    }
  },
  {
    accessorKey: 'phone',
    header: 'Phone',
    cell: ({ row: { original } }) => {
      const { phone } = original;
      return (
        <Link to={`tel:${phone}`} className="fw-bold text-1100">
          {phone}
        </Link>
      );
    },
    meta: {
      headerProps: {
        style: { width: '20%', minWidth: '200px' },
        className: 'pe-3'
      }
    }
  },
  {
    accessorKey: 'city',
    header: 'City',
    meta: {
      headerProps: { style: { width: '10%' } },
      cellProps: { className: 'text-900' }
    }
  },
  // {
  //   accessorKey: 'dateModified',
  //   header: 'Last Active',
  //   meta: {
  //     headerProps: {
  //       style: { width: '21%', minWidth: '200px' },
  //       className: 'text-end'
  //     },
  //     cellProps: {
  //       className: 'text-end text-700'
  //     }
  //   }
  // },
  {
    accessorKey: 'dateModified',
    header: 'Last Active',
    cell: ({ row: { original } }) => {
      const { dateModified } = original;
      const date = new Date(dateModified);
      return formatDistanceToNow(date, { addSuffix: true });
    },
    meta: {
      headerProps: {
        style: { width: '21%', minWidth: '200px' },
        className: 'text-end'
      },
      cellProps: {
        className: 'text-end text-700'
      }
    }
  },
  {
    accessorKey: 'dateCreated',
    header: 'Joined',
    cell: ({ row: { original } }) => {
      const { dateCreated } = original;
      const date = new Date(dateCreated);
      return formatDate(date, 'dd MMM yyyy');
    },
    meta: {
      headerProps: {
        style: { width: '19%', minWidth: '200px' },
        className: 'text-end pe-0'
      },
      cellProps: {
        className: 'text-700 text-end'
      }
    }
  }
];

const MembersTable = () => {
  return (
    <div>
      <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
      <AdvanceTableFooter pagination />
    </div>
  );
};

export default MembersTable;
